var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-vertical-demo",
      class: { min201: !_vm.isCollapse },
      attrs: {
        router: "",
        "default-active": _vm.thisKeyPath,
        collapse: _vm.isCollapse,
        "collapse-transition": _vm.transition
      },
      on: { select: _vm.headleSelect }
    },
    [
      _vm._l(_vm.asideNavList, function(item, index) {
        return [
          item.children
            ? _c(
                "el-submenu",
                { key: index, attrs: { index: item.path } },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", { class: item.icon }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.name))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-menu-item-group",
                    _vm._l(item.children, function(child, cIndex) {
                      return _c(
                        "el-menu-item",
                        { key: cIndex, attrs: { index: child.path } },
                        [_vm._v(_vm._s(child.name))]
                      )
                    }),
                    1
                  )
                ],
                2
              )
            : _c("el-menu-item", { key: index, attrs: { index: item.path } }, [
                _c("i", { class: item.icon }),
                _vm._v(" "),
                _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                  _vm._v(_vm._s(item.name))
                ])
              ])
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29a55538", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29a55538","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside.vue
// module id = 6OoZ
// module chunks = 1